package map.views.workplacetools

import apiclient.analytics.customFieldClause
import apiclient.geoobjects.ObjectTags
import apiclient.geoobjects.ObjectType
import apiclient.geoobjects.SearchQueryContext
import apiclient.tags.tag
import auth.WorkspacesStore
import dev.fritz2.core.RootStore
import koin.koinCtx
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.map
import model.fieldValues
import model.groupIds
import model.text

val archetypeSearchDefaultCtx = SearchQueryContext(
    objectTypes = listOf(ObjectType.GeneralMarker),
    tags = listOf(ObjectTags.IsArchetype.tag("true")),
)

class ArchetypeSearchContextStore : RootStore<SearchQueryContext>(
    initialData = archetypeSearchDefaultCtx,
    job = Job(),
) {
    private val workspacesStore: WorkspacesStore by koinCtx.inject()
    private val archetypeSearchInputFieldStore: ArchetypeSearchInputFieldStore by koinCtx.inject()
    private val activeArchetypeSearchKeywordsStore: ActiveArchetypeSearchKeywordsStore by koinCtx.inject()
    private val activeArchetypeSearchFieldValuesStore: ActiveArchetypeSearchFieldValuesStore by koinCtx.inject()
    private val ctxGroupIds = this.map(SearchQueryContext.groupIds())
    private val ctxText = this.map(SearchQueryContext.text())
    private val ctxFieldValues = this.map(SearchQueryContext.fieldValues())

    val reset = handle { _ ->
        archetypeSearchDefaultCtx
    }

    private val updateTags = handle<List<String>> { current, newTags ->

        val newVal = current.copy(tags = listOf(ObjectTags.IsArchetype.tag("true")) + newTags.map { ObjectTags.Keyword.tag(it) })
//        console.warn("ArchetypeSearchCtx tags:", newVal.tags.toString())
        newVal
    }

    init {
        workspacesStore.data.map { workspaces ->
            workspaces.mapNotNull { it.groupId.ifBlank { null } }
                .ifEmpty { null }
        } handledBy ctxGroupIds.update
        archetypeSearchInputFieldStore.data handledBy ctxText.update
        activeArchetypeSearchKeywordsStore.data handledBy updateTags
        activeArchetypeSearchFieldValuesStore.data.map { fieldValues ->
            fieldValues.map { it.customFieldClause }
        } handledBy ctxFieldValues.update
    }
}
